import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { get } from 'lodash-es'

import DataBoolean from 'syft-acp-core/components/EditableTable/DataBoolean'
import EntityListInputWrapper from 'syft-acp-core/components/EntityList/EntityListInputWrapper'
import { updateAgencyBookings } from 'syft-acp-core/actions/agency-bookings'

const ListingAgencyCheckbox = ({ dispatch, attr, shiftBooking, disabled = false }) => {
  const checked = get(shiftBooking, attr)
  const onChange = val => {
    const { id, shiftID } = shiftBooking
    dispatch(updateAgencyBookings({ shiftID, id, attr, val }))
  }

  return (
    <EntityListInputWrapper>
      <DataBoolean onChange={onChange} checked={checked} editable={!disabled} />
    </EntityListInputWrapper>
  )
}

ListingAgencyCheckbox.propTypes = {
  dispatch: PropTypes.func.isRequired,
  attr: PropTypes.string.isRequired,
  shiftBooking: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
}

export default connect()(ListingAgencyCheckbox)
